import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { ResourceDetailHeader } from 'js/components/ResourceDetailHeader';
import { Button } from 'new/elements/Button';
import { ConnectionTypeChip } from 'new/elements/ConnectionTypeChip/ConnectionTypeChip';
import { ProfileImage } from 'new/elements/ProfileImage';
import { ReactComponent as DomainIcon } from 'new/components/icons/fi-rr-globe-alt.svg';
import { ReactComponent as Delete } from 'new/components/icons/fi-rr-trash.svg';
import { deleteDomain, updateDomainInfo } from 'js/actions';
import { DataProducts } from '../../DataProducts';
import Menu from 'js/components/elements/menu/Menu';
import styles from './DomainDetailHeader.module.scss';
import { showAlert } from 'new/stores/showAlert/action';

interface DomainDetailHeaderProps {
  data: any;
  onCloseDrawer?(): void;
}

export const DomainDetailHeader = (props: DomainDetailHeaderProps) => {
  const dispatch = useDispatch<ThunkDispatch<any, any, Action>>();
  const history = useHistory();
  const { data, onCloseDrawer } = props;

  const handleInputChange = (domainId, info) => {
    dispatch(updateDomainInfo(domainId, info));
  };

  const handleViewDataProducts = (id: number) => {
    history.push(DataProducts.screenConfig.path + `/?domain_id=${id}`);
  };

  const onClickDeleteDomain = () => {
    dispatch(deleteDomain(data?.id)).then(() => {
      dispatch(
        showAlert({
          title: `Domain "${data.name}" deleted`,
          severity: 'success',
        }),
      );
    });
    onCloseDrawer();
  };

  const menuItems = [
    {
      type: 'dialog',
      label: 'Delete Data Domain',
      icon: <Delete />,
      color: 'error',
      dialogMessage: `Please confirm you want to delete: ${data.name} (Domain ID: ${data.id})`,
      discardLabel: 'Cancel',
      confirmLabel: 'Delete',
      onClick: onClickDeleteDomain,
    },
  ];

  return (
    <ResourceDetailHeader
      data={data}
      readOnly={!data?.hasCustodianAccess}
      updateInfo={handleInputChange}
      onCloseDrawer={props?.onCloseDrawer}
    >
      <ResourceDetailHeader.TopContent>
        <Stack direction="row" alignItems="center" justifyContent="space-between" gap="16px">
          <Stack direction="row" alignItems="center" gap="16px">
            <div className={styles.boxInfo}>
              <div className={styles.connectionContainer}>
                <ConnectionTypeChip icon={<DomainIcon />} label="Data Domain" />
              </div>
            </div>
            <div className={styles.boxInfo}>
              <Typography variant="body3">Created by</Typography>
              <ProfileImage
                color={'rgba(0,0,0,0.5)'}
                size="xxsmall"
                fullName={data?.owner?.full_name}
              />
              <Typography variant="body3">{data?.owner?.full_name}</Typography>
            </div>
          </Stack>
          <Stack direction="row" alignItems="center">
            <Button
              variant="outlined"
              style={{ backgroundColor: 'white' }}
              onClick={() => handleViewDataProducts(data?.id)}
            >
              View Data Products
            </Button>
            {data?.hasCustodianAccess ? <Menu items={menuItems} /> : null}
          </Stack>
        </Stack>
      </ResourceDetailHeader.TopContent>
    </ResourceDetailHeader>
  );
};
